import {Injectable} from '@angular/core';
import {ActivatedRoute, Params, Router} from "@angular/router";
import {FilterResultService} from "./filter-result.service";
import {FilterControls} from "../interface/filter-controls";
import {FilterKey} from "../interface/filter-key";
import {FilterCsvMetadataService} from "./filter-csv-metadata.service";
import {FilterOption} from "../interface/filter-option";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";


@UntilDestroy()
@Injectable({
	providedIn: 'root'
})
export class FilterUrlModifierService {


	constructor(
		private _router: Router,
		private _activatedRoute: ActivatedRoute,
		private _result: FilterResultService
	) {
	}

	public modify(controls: FilterControls): void {

		let queryParams: Params = {};



		controls.cohorts.forEach(cohort => {

			const filterKey: FilterKey = cohort.key;
			let subOptionKey: string = '';
			//TODO: change query param key?

			let filterValues: string[] = [];
			if (cohort.key.type === "range" && cohort.rangeCohort) {
				filterValues = this._result.getFilterValuesFromRange(
					cohort.rangeCohort
				);
			}


			if (cohort.cohort) {
				if (cohort.key.type === "csv") {
					if (cohort.key.key === "color") {
						filterValues = this._result.getFilterValuesFromCsv(
							cohort.cohort.options,
							FilterCsvMetadataService.colorList
						);
					} else if (cohort.key.key === "material") {
						filterValues = this._result.getFilterValuesFromCsv(
							cohort.cohort.options,
							FilterCsvMetadataService.materialList
						);
					} else if (cohort.key.key === "pattern") {
						filterValues = this._result.getFilterValuesFromCsv(
							cohort.cohort.options,
							FilterCsvMetadataService.patternList
						);
					}
				}
				else if(cohort.key.type === "sub")
				{
					cohort.cohort.options.forEach((control: FilterOption): void => {
						if(!control.subOptions)
							return;
						subOptionKey = control.value.toLowerCase().replace(/\s+/g, '-');
						filterValues = this._result.geFilterValuesFromSubCategoryControls(control.subOptions);
						if (filterValues.length > 0) {
							filterValues = filterValues.map((filter) => {
								if(filter.includes('-')) {
									return filter.toLowerCase().replace(/\s+/g, '');
								}
								return filter.toLowerCase().replace(/\s+/g, '-');
							});
							queryParams[subOptionKey] = encodeURIComponent(filterValues.join());
						}
					})
				}
				else if(cohort.key.type === "default") {
					filterValues = this._result.getFilterValuesFromKey(
						filterKey,
						cohort.cohort.options
					);
				}
				else if(cohort.key.type === "toggle") {
					if(cohort.cohort.options[0].active) {
						filterValues = ["true"]
					}
				}
			}
			if (filterValues.length > 0 && cohort.key.type !== 'sub')
			{
				filterValues = filterValues.map((filter) => filter.toLowerCase().replace(/\s+/g, '-'));
				queryParams[filterKey.key] = encodeURIComponent(filterValues.join());
			}

		});

		this._activatedRoute.queryParams
			.pipe(untilDestroyed(this))
			.subscribe((params: Params): void => {
				if(params['page']) {
					queryParams['page'] = encodeURIComponent(params['page']);
				}
			});

		this._router.navigate(
			[],
			{
				relativeTo: this._activatedRoute,
				queryParams: queryParams,
				queryParamsHandling: null
			}
		).then(r => {
			if (!r) console.error('error routing to query param!');
		});
	}
}
